import * as Yup from 'yup';

export default Yup.object({
  memoAD: Yup.string()
    .nullable()
    .max(500, '500文字以下で入力してください。'),
  memoSV: Yup.string()
    .nullable()
    .max(500, '500文字以下で入力してください。'),
  policyNumberRevised: Yup.string()
    .nullable()
    .matches(
      /^[a-zA-Z0-9]{10}$/,
      '正しく入力されていません。10桁の英数字を入力してください。'
    ),
  nameRevised: Yup.string()
    .nullable()
    .max(50, '50文字以下で入力してください。'),
  nameKanaRevised: Yup.string()
    .nullable()
    .max(50, '50文字以下で入力してください。')
    .matches(/^[ァ-ヶｦ-ﾟ]([ァ-ヶｦ-ﾟー\-‐‑–—―−ｰ－\s])*$/, 'カタカナで入力してください。'),
  memo: Yup.string()
    .nullable()
    .max(500, '500文字以下で入力してください。'),
  callDesignatedDate: Yup.string().when('callFlg', {
    is: (callFlg) => callFlg,
    then: Yup.string()
      .typeError('入力必須です。')
      .required('入力必須です。'),
    otherwise: Yup.string().nullable(),
  }),
  callDesignatedTimeAndMemo: Yup.string()
    .nullable()
    .when('callFlg', {
      is: (callFlg) => callFlg,
      then: Yup.string().max(500, '500文字以下で入力してください。'),
    }),
  callHistories: Yup.array().of(
    Yup.object({
      id: Yup.number().nullable(),
      outboundDate: Yup.string().required('入力必須です。'),
      memo: Yup.string().max(500, '500文字以下で入力してください。'),
    })
  ),
  responseStatus: Yup.string().required('入力必須です。'),
});
